class FocusTrap {
  constructor(element) {
    if (typeof element === 'string' || element instanceof String) {
      this.container = document.querySelector(element);
    } else {
      this.container = element;
    }

    this.selectors = {
      focusable: 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
    };

    const elements = [...this.container.querySelectorAll(this.selectors.focusable)]
      .filter((item) => !item.disabled);

    this.firstElement = elements.shift();
    this.lastElement = elements.pop() || this.firstElement;

    this.handle = this.handle.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);
  }

  handle(event) {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === this.firstElement) {
          event.preventDefault();

          this.lastElement.focus();
        }
      } else if (document.activeElement === this.lastElement) {
        event.preventDefault();

        this.firstElement.focus();
      }
    }
  }

  enable() {
    document.addEventListener('keydown', this.handle);
  }

  disable() {
    document.removeEventListener('keydown', this.handle);
  }
}

export default (element) => new FocusTrap(element);
